/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

import React from 'react'

/** Reminds the admin that nothing here auto-saves. */
export const UnsavedChangesNote: React.FC<{ show: boolean }> = ({ show }) =>
  show ? (
    <p className="mt-2 text-right text-sm text-warning" data-testid="unsaved-changes" role="status">
      You have unsaved changes
    </p>
  ) : null

export default UnsavedChangesNote
